import { TableAction } from '../../../../../components/ModularDataTable'
import { i18n } from '../../../../../translate/i18n'

type ActionsFactoryParams = {
  navigate: (path: string) => void
  showDeleteModal: (title: string) => void
  setVariationId: (id: number) => void
  isAdmin: boolean
}

export function createActions({
  navigate,
  showDeleteModal,
  setVariationId,
  isAdmin,
}: ActionsFactoryParams): TableAction[] {
  const editLabel = `${i18n.t(`general.edit`)} ${i18n.t(`smart_order.variation`)}`
  const deleteLabel = `${i18n.t(`general.delete`)} ${i18n.t(`smart_order.variation`)}`

  const actions: TableAction[] = [
    {
      icon: 'fas fa-pen',
      label: editLabel,
      action: (item: any) => navigate(`/variation/editar/${item.id}`),
    },
  ]

  if (isAdmin) {
    actions.push({
      icon: 'fas fa-trash',
      label: deleteLabel,
      action: (item: any) => {
        showDeleteModal(deleteLabel)
        setVariationId(item.id)
      },
    })
  }

  return actions
}
